import { __assign, __rest, __values } from "tslib";
import { lexicalAnalysis } from './lexicalAnalysis';
import { simplifyAST } from './simplifyAST';
var createError = function (message, err) {
    if (err instanceof Error) {
        return new Error("".concat(err.message.trim(), "\n").concat(message.trim()));
    }
    else {
        return new Error(message.trim());
    }
};
export var toAST = function (str) {
    return simplifyAST(toUnflattenedAST(str));
};
export var toUnflattenedAST = function (str) {
    var tokenList = lexicalAnalysis(str.trim());
    if (tokenList === null) {
        throw createError('Failed tokenizing');
    }
    var startIndex = 0;
    var endIndex = tokenList.length - 1;
    if (tokenList[0].type === '<at-keyword-token>' &&
        tokenList[0].value === 'media') {
        if (tokenList[1].type !== '<whitespace-token>') {
            throw createError('Expected whitespace after media');
        }
        startIndex = 2;
        for (var i = 2; i < tokenList.length - 1; i++) {
            var token = tokenList[i];
            if (token.type === '<{-token>') {
                endIndex = i;
                break;
            }
            else if (token.type === '<semicolon-token>') {
                throw createError("Expected '{' in media query but found ';'");
            }
        }
    }
    tokenList = tokenList.slice(startIndex, endIndex);
    return syntacticAnalysis(tokenList);
};
export var removeWhitespace = function (tokenList) {
    var newTokenList = [];
    var before = false;
    for (var i = 0; i < tokenList.length; i++) {
        if (tokenList[i].type === '<whitespace-token>') {
            before = true;
            if (newTokenList.length > 0) {
                newTokenList[newTokenList.length - 1].wsAfter = true;
            }
        }
        else {
            newTokenList.push(__assign(__assign({}, tokenList[i]), { wsBefore: before, wsAfter: false }));
            before = false;
        }
    }
    return newTokenList;
};
export var syntacticAnalysis = function (tokenList) {
    var e_1, _a;
    var mediaQueryList = [[]];
    for (var i = 0; i < tokenList.length; i++) {
        var token = tokenList[i];
        if (token.type === '<comma-token>') {
            mediaQueryList.push([]);
        }
        else {
            mediaQueryList[mediaQueryList.length - 1].push(token);
        }
    }
    var mediaQueries = mediaQueryList.map(removeWhitespace);
    if (mediaQueries.length === 1 && mediaQueries[0].length === 0) {
        return [{ mediaCondition: null, mediaPrefix: null, mediaType: 'all' }];
    }
    else {
        var mediaQueryTokens = mediaQueries.map(function (mediaQueryTokens) {
            if (mediaQueryTokens.length === 0) {
                return null;
            }
            else {
                return tokenizeMediaQuery(mediaQueryTokens);
            }
        });
        var nonNullMediaQueryTokens = [];
        try {
            for (var mediaQueryTokens_1 = __values(mediaQueryTokens), mediaQueryTokens_1_1 = mediaQueryTokens_1.next(); !mediaQueryTokens_1_1.done; mediaQueryTokens_1_1 = mediaQueryTokens_1.next()) {
                var mediaQueryToken = mediaQueryTokens_1_1.value;
                if (mediaQueryToken !== null) {
                    nonNullMediaQueryTokens.push(mediaQueryToken);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (mediaQueryTokens_1_1 && !mediaQueryTokens_1_1.done && (_a = mediaQueryTokens_1.return)) _a.call(mediaQueryTokens_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (nonNullMediaQueryTokens.length === 0) {
            throw createError('No valid media queries');
        }
        return nonNullMediaQueryTokens;
    }
};
export var tokenizeMediaQuery = function (tokens) {
    var firstToken = tokens[0];
    if (firstToken.type === '<(-token>') {
        try {
            return {
                mediaPrefix: null,
                mediaType: 'all',
                mediaCondition: tokenizeMediaCondition(tokens, true)
            };
        }
        catch (err) {
            throw createError("Expected media condition after '('", err);
        }
    }
    else if (firstToken.type === '<ident-token>') {
        var mediaPrefix = null;
        var mediaType = void 0;
        var value = firstToken.value;
        if (value === 'only' || value === 'not') {
            mediaPrefix = value;
        }
        var firstIndex = mediaPrefix === null ? 0 : 1;
        if (tokens.length <= firstIndex) {
            throw createError("Expected extra token in media query");
        }
        var firstNonUnaryToken = tokens[firstIndex];
        if (firstNonUnaryToken.type === '<ident-token>') {
            var value_1 = firstNonUnaryToken.value;
            if (value_1 === 'all') {
                mediaType = 'all';
            }
            else if (value_1 === 'print' || value_1 === 'screen') {
                mediaType = value_1;
            }
            else if (value_1 === 'tty' ||
                value_1 === 'tv' ||
                value_1 === 'projection' ||
                value_1 === 'handheld' ||
                value_1 === 'braille' ||
                value_1 === 'embossed' ||
                value_1 === 'aural' ||
                value_1 === 'speech') {
                mediaPrefix = mediaPrefix === 'not' ? null : 'not';
                mediaType = 'all';
            }
            else {
                throw createError("Unknown ident '".concat(value_1, "' in media query"));
            }
        }
        else if (mediaPrefix === 'not' &&
            firstNonUnaryToken.type === '<(-token>') {
            var tokensWithParens = [
                { type: '<(-token>', wsBefore: false, wsAfter: false }
            ];
            tokensWithParens.push.apply(tokensWithParens, tokens);
            tokensWithParens.push({
                type: '<)-token>',
                wsBefore: false,
                wsAfter: false
            });
            try {
                return {
                    mediaPrefix: null,
                    mediaType: 'all',
                    mediaCondition: tokenizeMediaCondition(tokensWithParens, true)
                };
            }
            catch (err) {
                throw createError("Expected media condition after '('", err);
            }
        }
        else {
            throw createError('Invalid media query');
        }
        if (firstIndex + 1 === tokens.length) {
            return {
                mediaPrefix: mediaPrefix,
                mediaType: mediaType,
                mediaCondition: null
            };
        }
        else if (firstIndex + 4 < tokens.length) {
            var secondNonUnaryToken = tokens[firstIndex + 1];
            if (secondNonUnaryToken.type === '<ident-token>' &&
                secondNonUnaryToken.value === 'and') {
                try {
                    return {
                        mediaPrefix: mediaPrefix,
                        mediaType: mediaType,
                        mediaCondition: tokenizeMediaCondition(tokens.slice(firstIndex + 2), false)
                    };
                }
                catch (err) {
                    throw createError("Expected media condition after 'and'", err);
                }
            }
            else {
                throw createError("Expected 'and' after media prefix");
            }
        }
        else {
            throw createError('Expected media condition after media prefix');
        }
    }
    else {
        throw createError('Expected media condition or media prefix');
    }
};
export var tokenizeMediaCondition = function (tokens, mayContainOr, previousOperator) {
    if (previousOperator === void 0) { previousOperator = null; }
    if (tokens.length < 3 ||
        tokens[0].type !== '<(-token>' ||
        tokens[tokens.length - 1].type !== '<)-token>') {
        throw new Error('Invalid media condition');
    }
    var endIndexOfFirstFeature = tokens.length - 1;
    var maxDepth = 0;
    var count = 0;
    for (var i = 0; i < tokens.length; i++) {
        var token = tokens[i];
        if (token.type === '<(-token>') {
            count += 1;
            maxDepth = Math.max(maxDepth, count);
        }
        else if (token.type === '<)-token>') {
            count -= 1;
        }
        if (count === 0) {
            endIndexOfFirstFeature = i;
            break;
        }
    }
    if (count !== 0) {
        throw new Error('Mismatched parens\nInvalid media condition');
    }
    var child;
    var featureTokens = tokens.slice(0, endIndexOfFirstFeature + 1);
    if (maxDepth === 1) {
        child = tokenizeMediaFeature(featureTokens);
    }
    else {
        if (featureTokens[1].type === '<ident-token>' &&
            featureTokens[1].value === 'not') {
            child = tokenizeMediaCondition(featureTokens.slice(2, -1), true, 'not');
        }
        else {
            child = tokenizeMediaCondition(featureTokens.slice(1, -1), true);
        }
    }
    if (endIndexOfFirstFeature === tokens.length - 1) {
        return {
            operator: previousOperator,
            children: [child]
        };
    }
    else {
        var nextToken = tokens[endIndexOfFirstFeature + 1];
        if (nextToken.type !== '<ident-token>') {
            throw new Error('Invalid operator\nInvalid media condition');
        }
        else if (previousOperator !== null &&
            previousOperator !== nextToken.value) {
            throw new Error("'".concat(nextToken.value, "' and '").concat(previousOperator, "' must not be at same level\nInvalid media condition"));
        }
        else if (nextToken.value === 'or' && !mayContainOr) {
            throw new Error("Cannot use 'or' at top level of a media query\nInvalid media condition");
        }
        else if (nextToken.value !== 'and' && nextToken.value !== 'or') {
            throw new Error("Invalid operator: '".concat(nextToken.value, "'\nInvalid media condition"));
        }
        var siblings = tokenizeMediaCondition(tokens.slice(endIndexOfFirstFeature + 2), mayContainOr, nextToken.value);
        return {
            operator: nextToken.value,
            children: [child].concat(siblings.children)
        };
    }
};
export var tokenizeMediaFeature = function (rawTokens) {
    if (rawTokens.length < 3 ||
        rawTokens[0].type !== '<(-token>' ||
        rawTokens[rawTokens.length - 1].type !== '<)-token>') {
        throw new Error('Invalid media feature');
    }
    var tokens = [rawTokens[0]];
    for (var i = 1; i < rawTokens.length; i++) {
        if (i < rawTokens.length - 2) {
            var a = rawTokens[i];
            var b = rawTokens[i + 1];
            var c = rawTokens[i + 2];
            if (a.type === '<number-token>' &&
                a.value > 0 &&
                b.type === '<delim-token>' &&
                b.value === 0x002f &&
                c.type === '<number-token>' &&
                c.value > 0) {
                tokens.push({
                    type: '<ratio-token>',
                    numerator: a.value,
                    denominator: c.value,
                    wsBefore: a.wsBefore,
                    wsAfter: c.wsAfter
                });
                i += 2;
                continue;
            }
        }
        tokens.push(rawTokens[i]);
    }
    var nextToken = tokens[1];
    if (nextToken.type === '<ident-token>' && tokens.length === 3) {
        return {
            context: 'boolean',
            feature: nextToken.value
        };
    }
    else if (tokens.length === 5 &&
        tokens[1].type === '<ident-token>' &&
        tokens[2].type === '<colon-token>') {
        var valueToken = tokens[3];
        if (valueToken.type === '<number-token>' ||
            valueToken.type === '<dimension-token>' ||
            valueToken.type === '<ratio-token>' ||
            valueToken.type === '<ident-token>') {
            var feature = tokens[1].value;
            var prefix = null;
            var slice = feature.slice(0, 4);
            if (slice === 'min-') {
                prefix = 'min';
                feature = feature.slice(4);
            }
            else if (slice === 'max-') {
                prefix = 'max';
                feature = feature.slice(4);
            }
            var _0 = valueToken.wsBefore, _1 = valueToken.wsAfter, value = __rest(valueToken, ["wsBefore", "wsAfter"]);
            return {
                context: 'value',
                prefix: prefix,
                feature: feature,
                value: value
            };
        }
    }
    else if (tokens.length >= 5) {
        try {
            var range = tokenizeRange(tokens);
            return {
                context: 'range',
                feature: range.featureName,
                range: range
            };
        }
        catch (err) {
            throw createError('Invalid media feature', err);
        }
    }
    throw new Error('Invalid media feature');
};
export var tokenizeRange = function (tokens) {
    var _a, _b, _c, _d;
    if (tokens.length < 5 ||
        tokens[0].type !== '<(-token>' ||
        tokens[tokens.length - 1].type !== '<)-token>') {
        throw new Error('Invalid range');
    }
    var range = {
        leftToken: null,
        leftOp: null,
        featureName: '',
        rightOp: null,
        rightToken: null
    };
    var hasLeft = tokens[1].type === '<number-token>' ||
        tokens[1].type === '<dimension-token>' ||
        tokens[1].type === '<ratio-token>' ||
        (tokens[1].type === '<ident-token>' && tokens[1].value === 'infinite');
    if (tokens[2].type === '<delim-token>') {
        if (tokens[2].value === 0x003c) {
            if (tokens[3].type === '<delim-token>' &&
                tokens[3].value === 0x003d &&
                !tokens[3].wsBefore) {
                range[hasLeft ? 'leftOp' : 'rightOp'] = '<=';
            }
            else {
                range[hasLeft ? 'leftOp' : 'rightOp'] = '<';
            }
        }
        else if (tokens[2].value === 0x003e) {
            if (tokens[3].type === '<delim-token>' &&
                tokens[3].value === 0x003d &&
                !tokens[3].wsBefore) {
                range[hasLeft ? 'leftOp' : 'rightOp'] = '>=';
            }
            else {
                range[hasLeft ? 'leftOp' : 'rightOp'] = '>';
            }
        }
        else if (tokens[2].value === 0x003d) {
            range[hasLeft ? 'leftOp' : 'rightOp'] = '=';
        }
        else {
            throw new Error('Invalid range');
        }
        if (hasLeft) {
            range.leftToken = tokens[1];
        }
        else if (tokens[1].type === '<ident-token>') {
            range.featureName = tokens[1].value;
        }
        else {
            throw new Error('Invalid range');
        }
        var tokenIndexAfterFirstOp = 2 + ((_b = (_a = range[hasLeft ? 'leftOp' : 'rightOp']) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0);
        var tokenAfterFirstOp = tokens[tokenIndexAfterFirstOp];
        if (hasLeft) {
            if (tokenAfterFirstOp.type === '<ident-token>') {
                range.featureName = tokenAfterFirstOp.value;
                if (tokens.length >= 7) {
                    var secondOpToken = tokens[tokenIndexAfterFirstOp + 1];
                    var followingToken = tokens[tokenIndexAfterFirstOp + 2];
                    if (secondOpToken.type === '<delim-token>') {
                        var charCode = secondOpToken.value;
                        if (charCode === 0x003c) {
                            if (followingToken.type === '<delim-token>' &&
                                followingToken.value === 0x003d &&
                                !followingToken.wsBefore) {
                                range.rightOp = '<=';
                            }
                            else {
                                range.rightOp = '<';
                            }
                        }
                        else if (charCode === 0x003e) {
                            if (followingToken.type === '<delim-token>' &&
                                followingToken.value === 0x003d &&
                                !followingToken.wsBefore) {
                                range.rightOp = '>=';
                            }
                            else {
                                range.rightOp = '>';
                            }
                        }
                        else {
                            throw new Error('Invalid range');
                        }
                        var tokenAfterSecondOp = tokens[tokenIndexAfterFirstOp + 1 + ((_d = (_c = range.rightOp) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0)];
                        range.rightToken = tokenAfterSecondOp;
                    }
                    else {
                        throw new Error('Invalid range');
                    }
                }
                else if (tokenIndexAfterFirstOp + 2 !== tokens.length) {
                    throw new Error('Invalid range');
                }
            }
            else {
                throw new Error('Invalid range');
            }
        }
        else {
            range.rightToken = tokenAfterFirstOp;
        }
        var validRange = null;
        var lt = range.leftToken, leftOp = range.leftOp, featureName = range.featureName, rightOp = range.rightOp, rt = range.rightToken;
        var leftToken = null;
        if (lt !== null) {
            if (lt.type === '<ident-token>') {
                var type = lt.type, value = lt.value;
                if (value === 'infinite') {
                    leftToken = { type: type, value: value };
                }
            }
            else if (lt.type === '<number-token>' ||
                lt.type === '<dimension-token>' ||
                lt.type === '<ratio-token>') {
                var _0 = lt.wsBefore, _1 = lt.wsAfter, ltNoWS = __rest(lt, ["wsBefore", "wsAfter"]);
                leftToken = ltNoWS;
            }
        }
        var rightToken = null;
        if (rt !== null) {
            if (rt.type === '<ident-token>') {
                var type = rt.type, value = rt.value;
                if (value === 'infinite') {
                    rightToken = { type: type, value: value };
                }
            }
            else if (rt.type === '<number-token>' ||
                rt.type === '<dimension-token>' ||
                rt.type === '<ratio-token>') {
                var _0 = rt.wsBefore, _1 = rt.wsAfter, rtNoWS = __rest(rt, ["wsBefore", "wsAfter"]);
                rightToken = rtNoWS;
            }
        }
        if (leftToken !== null && rightToken !== null) {
            if ((leftOp === '<' || leftOp === '<=') &&
                (rightOp === '<' || rightOp === '<=')) {
                validRange = { leftToken: leftToken, leftOp: leftOp, featureName: featureName, rightOp: rightOp, rightToken: rightToken };
            }
            else if ((leftOp === '>' || leftOp === '>=') &&
                (rightOp === '>' || rightOp === '>=')) {
                validRange = { leftToken: leftToken, leftOp: leftOp, featureName: featureName, rightOp: rightOp, rightToken: rightToken };
            }
            else {
                throw new Error('Invalid range');
            }
        }
        else if (leftToken === null &&
            leftOp === null &&
            rightOp !== null &&
            rightToken !== null) {
            validRange = { leftToken: leftToken, leftOp: leftOp, featureName: featureName, rightOp: rightOp, rightToken: rightToken };
        }
        else if (leftToken !== null &&
            leftOp !== null &&
            rightOp === null &&
            rightToken === null) {
            validRange = { leftToken: leftToken, leftOp: leftOp, featureName: featureName, rightOp: rightOp, rightToken: rightToken };
        }
        return validRange;
    }
    else {
        throw new Error('Invalid range');
    }
};
//# sourceMappingURL=syntacticAnalysis.js.map